import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AfterViewInit, Component, inject } from '@angular/core';
import { PaToggleSwitchComponent } from '../../../../shared/ui-kit/pa-toggle-switch/pa-toggle-switch.component';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'app-toggle-switch-view',
  templateUrl: './toggle-switch-view.component.html',
  styleUrls: ['./toggle-switch-view.component.scss'],
  standalone: true,
  imports: [PaToggleSwitchComponent, FormsModule, ReactiveFormsModule],
})
export class ToggleSwitchViewComponent implements AfterViewInit {
  private fb = inject(FormBuilder);

  form = this.fb.group({
    isEnabled: new FormControl(false),
  });

  form2 = this.fb.group({
    isDisabled: new FormControl({ value: false, disabled: true }),
  });

  form3 = this.fb.group({
    isRequired: new FormControl(true, Validators.required),
  });

  form4 = this.fb.group({
    isRequired: new FormControl(false, this.toggleRequiredValidator()),
  });

  toggleRequiredValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      return control.value === true ? null : { required: true };
    };
  }

  toggleErrorMessages = {
    required: 'Необходимо включить переключатель.',
  };

  ngAfterViewInit(): void {
    const control = this.form4.get('isRequired');
    if (control) {
      control.markAsTouched();
      control.updateValueAndValidity();
    }
  }
}
